const regions = [
	{
		marketplace: 'Mexico',
		country_code: 'MX',
		endpoint: 'https://mws.amazonservices.com.mx',
		MarketplaceId: 'A1AM78C64UM0Y8',
		partner_endpoint: 'sellingpartnerapi-na.amazon.com',
		partner_endpoint_sandbox: 'sandbox.sellingpartnerapi-na.amazon.com',
		region: 'us-east-1',
	},
	{
		marketplace: 'France',
		country_code: 'FR',
		endpoint: 'https://mws-eu.amazonservices.com',
		MarketplaceId: 'A13V1IB3VIYZZH',
		partner_endpoint: 'sellingpartnerapi-eu.amazon.com',
		partner_endpoint_sandbox: 'sandbox.sellingpartnerapi-eu.amazon.com',
		region: 'eu-west-1',
		url: 'https://www.amazon.fr/',
	},
	{
		marketplace: 'United Arab Emirates (U.A.E.)',
		country_code: 'AE',
		endpoint: 'https://mws-eu.amazonservices.com',
		MarketplaceId: 'A2VIGQ35RCS4UG',
		partner_endpoint: 'sellingpartnerapi-eu.amazon.com',
		partner_endpoint_sandbox: 'sandbox.sellingpartnerapi-eu.amazon.com',
		region: 'eu-west-1',
		url: '',
	},
	{
		marketplace: 'Singapore',
		country_code: 'SG',
		endpoint: 'https://mws-fe.amazonservices.com',
		MarketplaceId: 'A19VAU5U5O7RUS',
		partner_endpoint: 'sellingpartnerapi-fe.amazon.com',
		partner_endpoint_sandbox: 'sandbox.sellingpartnerapi-fe.amazon.com',
		region: 'us-west-2',
	},
	{
		marketplace: 'Germany',
		country_code: 'DE',
		endpoint: 'https://mws-eu.amazonservices.com',
		MarketplaceId: 'A1PA6795UKMFR9',
		partner_endpoint: 'sellingpartnerapi-eu.amazon.com',
		partner_endpoint_sandbox: 'sandbox.sellingpartnerapi-eu.amazon.com',
		region: 'eu-west-1',
		url: 'https://www.amazon.de/',
	},
	{
		marketplace: 'Egypt',
		country_code: 'EG',
		endpoint: 'https://mws-eu.amazonservices.com',
		MarketplaceId: 'ARBP9OOSHTCHU',
		partner_endpoint: 'sellingpartnerapi-eu.amazon.com',
		partner_endpoint_sandbox: 'sandbox.sellingpartnerapi-eu.amazon.com',
		region: 'eu-west-1',
	},
	{
		marketplace: 'US',
		country_code: 'US',
		endpoint: 'https://mws.amazonservices.com',
		MarketplaceId: 'ATVPDKIKX0DER',
		partner_endpoint: 'sellingpartnerapi-na.amazon.com',
		partner_endpoint_sandbox: 'sandbox.sellingpartnerapi-na.amazon.com',
		region: 'us-east-1',
	},
	{
		marketplace: 'Turkey',
		country_code: 'TR',
		endpoint: 'https://mws-eu.amazonservices.com',
		MarketplaceId: 'A33AVAJ2PDY3EV',
		partner_endpoint: 'sellingpartnerapi-eu.amazon.com',
		partner_endpoint_sandbox: 'sandbox.sellingpartnerapi-eu.amazon.com',
		region: 'eu-west-1',
		url: 'https://www.amazon.com.tr/',
	},
	{
		marketplace: 'Canada',
		country_code: 'CA',
		endpoint: 'https://mws.amazonservices.ca',
		MarketplaceId: 'A2EUQ1WTGCTBG2',
		partner_endpoint: 'sellingpartnerapi-na.amazon.com',
		partner_endpoint_sandbox: 'sandbox.sellingpartnerapi-na.amazon.com',
		region: 'us-east-1',
	},
	{
		marketplace: 'UK',
		country_code: 'GB',
		endpoint: 'https://mws-eu.amazonservices.com',
		MarketplaceId: 'A1F83G8C2ARO7P',
		partner_endpoint: 'sellingpartnerapi-eu.amazon.com',
		partner_endpoint_sandbox: 'sandbox.sellingpartnerapi-eu.amazon.com',
		region: 'eu-west-1',
		url: 'https://www.amazon.co.uk/',
	},
	{
		marketplace: 'Sweden',
		country_code: 'SE',
		endpoint: 'https://mws-eu.amazonservices.com',
		MarketplaceId: 'A2NODRKZP88ZB9',
		partner_endpoint: 'sellingpartnerapi-eu.amazon.com',
		partner_endpoint_sandbox: 'sandbox.sellingpartnerapi-eu.amazon.com',
		region: 'eu-west-1',
		url: 'https://www.amazon.se/',
	},
	{
		marketplace: 'Japan',
		country_code: 'JP',
		endpoint: 'https://mws.amazonservices.jp',
		MarketplaceId: 'A1VC38T7YXB528',
		partner_endpoint: 'sellingpartnerapi-fe.amazon.com',
		partner_endpoint_sandbox: 'sandbox.sellingpartnerapi-fe.amazon.com',
		region: 'us-west-2',
	},
	{
		marketplace: 'Saudi Arabia',
		country_code: 'SA',
		endpoint: 'https://mws-eu.amazonservices.com',
		MarketplaceId: 'A17E79C6D8DWNP',
		partner_endpoint: 'sellingpartnerapi-eu.amazon.com',
		partner_endpoint_sandbox: 'sandbox.sellingpartnerapi-eu.amazon.com',
		region: 'eu-west-1',
	},
	{
		marketplace: 'Italy',
		country_code: 'IT',
		endpoint: 'https://mws-eu.amazonservices.com',
		MarketplaceId: 'APJ6JRA9NG5V4',
		partner_endpoint: 'sellingpartnerapi-eu.amazon.com',
		partner_endpoint_sandbox: 'sandbox.sellingpartnerapi-eu.amazon.com',
		region: 'eu-west-1',
		url: 'https://www.amazon.it/',
	},
	{
		marketplace: 'Ireland',
		country_code: 'IE',
		endpoint: 'https://mws-eu.amazonservices.com',
		MarketplaceId: 'A28R8C7NBKEWEA',
		partner_endpoint: 'sellingpartnerapi-eu.amazon.com',
		partner_endpoint_sandbox: 'sandbox.sellingpartnerapi-eu.amazon.com',
		region: 'eu-west-1',
		url: 'https://www.amazon.ir/',
	},
	{
		marketplace: 'Australia',
		country_code: 'AU',
		endpoint: 'https://mws.amazonservices.com.au',
		MarketplaceId: 'A39IBJ37TRP1C6',
		partner_endpoint: 'sellingpartnerapi-fe.amazon.com',
		partner_endpoint_sandbox: 'sandbox.sellingpartnerapi-fe.amazon.com',
		region: 'us-west-2',
	},
	{
		marketplace: 'Spain',
		country_code: 'ES',
		endpoint: 'https://mws-eu.amazonservices.com',
		MarketplaceId: 'A1RKKUPIHCS9HS',
		partner_endpoint: 'sellingpartnerapi-eu.amazon.com',
		partner_endpoint_sandbox: 'sandbox.sellingpartnerapi-eu.amazon.com',
		region: 'eu-west-1',
		url: 'https://www.amazon.es/',
	},
	{
		marketplace: 'Brazil',
		country_code: 'BR',
		endpoint: 'https://mws.amazonservices.com',
		MarketplaceId: 'A2Q3Y263D00KWC',
		partner_endpoint: 'sellingpartnerapi-na.amazon.com',
		partner_endpoint_sandbox: 'sandbox.sellingpartnerapi-na.amazon.com',
		region: 'us-east-1',
	},
	{
		marketplace: 'Poland',
		country_code: 'PL',
		endpoint: 'https://mws-eu.amazonservices.com',
		MarketplaceId: 'A1C3SOZRARQ6R3',
		partner_endpoint: 'sellingpartnerapi-eu.amazon.com',
		partner_endpoint_sandbox: 'sandbox.sellingpartnerapi-eu.amazon.com',
		region: 'eu-west-1',
		url: 'https://www.amazon.pl/',
	},
	{
		marketplace: 'India',
		country_code: 'IN',
		endpoint: 'https://mws.amazonservices.in',
		MarketplaceId: 'A21TJRUUN4KGV',
		partner_endpoint: 'sellingpartnerapi-eu.amazon.com',
		partner_endpoint_sandbox: 'sandbox.sellingpartnerapi-eu.amazon.com',
		region: 'eu-west-1',
	},
	{
		marketplace: 'Netherlands',
		country_code: 'NL',
		endpoint: 'https://mws-eu.amazonservices.com',
		MarketplaceId: 'A1805IZSGTT6HS',
		partner_endpoint: 'sellingpartnerapi-eu.amazon.com',
		partner_endpoint_sandbox: 'sandbox.sellingpartnerapi-eu.amazon.com',
		region: 'eu-west-1',
		url: 'https://www.amazon.nl/',
	},
	{
		marketplace: 'Belgium',
		country_code: 'BE',
		endpoint: 'https://mws-eu.amazonservices.com',
		MarketplaceId: 'AMEN7PMS3EDWL',
		partner_endpoint: 'sellingpartnerapi-eu.amazon.com',
		partner_endpoint_sandbox: 'sandbox.sellingpartnerapi-eu.amazon.com',
		region: 'eu-west-1',
		url: 'https://www.amazon.fr/',
	},
];

module.exports = {
	regions,
};
